import SearchController from '../modules/search';
import FavoriteController from '../modules/favorite';
import LikeController from '../modules/LikeController';
import SwiperController from '../modules/SwiperController';
import CommentUpload from '../modules/commentUpload';
import RecipePageScrollController from '../modules/recipePageScroll';
import UserProfileSettings from '../modules/userProfileSettings';
import Contact from '../modules/Contact';
import HeroSlideshow from '../modules/heroSlideshow';
import MealPlanController from '../modules/MealPlanController';
import SectionSelectorController from '../modules/SectionSelector';
import $ from 'jquery';

export default {
  searchController: null,
  favoriteController: null,
  likeController: null,
  commentUploadController: null,
  recipePageScrollController: null,
  swiperController: null,
  userProfileSettingsController: null,
  contactController: null,
  heroSlideshowController: null,
  mealPlanController: null,
  sectionSelectorController: null,

  init() {
    this.searchController = new SearchController();
    this.favoriteController = new FavoriteController();
    this.likeController = new LikeController();
    this.commentUploadController = new CommentUpload();
    this.recipePageScrollController = new RecipePageScrollController();
    this.swiperController = new SwiperController();
    this.userProfileSettingsController = new UserProfileSettings();
    this.contactController = new Contact();
    this.heroSlideshowController = new HeroSlideshow();
    this.mealPlanController = new MealPlanController();
    this.sectionSelectorController = new SectionSelectorController();

    // Toggle the hamburger menu icon
    $('.hamburger').click(function() {
      $(this).toggleClass('is-active');
      $('#sidebar-nav').toggleClass('is-active');
    });

    // Hide nutrition tab on recipes and meal plan pages
    console.log($('#nutrition').length);
    if ($('#nutrition').length < 1) {
      $('#nutrition-nav-item').addClass('d-none');
    }
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js